import React from 'react';

function ArrowUp(props) {
  return (
    <svg width="15" height="8" viewBox="0 0 15 8" fill="#3E3E40" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.4518 0.00241929C7.3002 0.0133217 7.15541 0.0769213 7.04128 0.184132L0.227635 6.72578C-0.0534267 6.99472 -0.0772743 7.45626 0.173127 7.75609C0.425232 8.05592 0.857898 8.08136 1.13896 7.81424C1.14066 7.81242 1.14066 7.81242 1.14237 7.8106L7.4995 1.70507L13.8566 7.8106C14.136 8.08135 14.5686 8.05955 14.8225 7.75973C15.0763 7.46172 15.0558 7.00017 14.7748 6.72942C14.7731 6.72761 14.7731 6.7276 14.7714 6.72578L7.95771 0.184132C7.81974 0.0532988 7.63747 -0.0139348 7.4518 0.00241929Z" />
    </svg>
  );
}

export default ArrowUp;
